/* eslint-disable */
import { Column } from "material-table";
import moment from "moment";
import { convertScheduleDate } from "../../../../utils/format";

export const columnsPrivate = () => {
    /** @type Column */
    const columns = [
        {
            title: "Booking Date",
            field: "bookingStartDate",
            render: row => convertScheduleDate(row?.bookingStartDate),
        },
        {
            title: "Start Time",
            field: "bookingStartDate",
            render: row => (row?.bookingStartDate ? moment(row?.bookingStartDate).format("HH:mm") : ""),
        },
        {
            title: "End Time",
            field: "bookingEndDate",
            render: row => (row?.bookingEndDate ? moment(row?.bookingEndDate).format("HH:mm") : ""),
        },
        {
            title: "Student",
            field: "SchedulePrivate.Student.studentFirstname",
            render: row =>
                `${row?.SchedulePrivate?.Student?.studentFirstname || ""} ${row?.SchedulePrivate?.Student
                    ?.studentLastname || ""}`,
        },
        {
            title: "Booking No.",
            field: "SchedulePrivate.Order.bookingNo",
        },
        {
            title: "Course",
            field: "Course.courseName",
        },
        {
            title: "Menu",
            field: "CourseMenu.courseMenuName",
        },
        {
            title: "Teacher",
            field: "Teacher.teacherFirstname",
            render: row => `${row?.Teacher?.teacherFirstname || ""} ${row?.Teacher?.teacherLastname || ""}`,
        },
        {
            title: "Classroom",
            field: "Classroom.classroomName",
        },
        {
            title: "Note",
            field: "SchedulePrivate.note",
        },
    ];
    const data = columns?.map((col, index) => ({
        ...col,
        cellStyle: { textAlign: "center" },
    }));
    return data;
};
